export default "__VITE_ASSET__DSgM8IZu__"